// src/firebase/config.ts

import { initializeApp } from 'firebase/app';
import {
  getAuth,
  setPersistence,
  browserLocalPersistence
} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import {
  getFunctions,
  // connectFunctionsEmulator
} from 'firebase/functions';
import { getStorage } from 'firebase/storage';

// Use your existing config values:
const firebaseConfig = {
  apiKey: "AIzaSyDFQjaTJK4Q18YCzrh3f5FmtbHBeF3exFU",
  authDomain: "invites-platform.firebaseapp.com",
  databaseURL: "https://invites-platform-default-rtdb.firebaseio.com",
  projectId: "invites-platform",
  storageBucket: "invites-platform.firebasestorage.app",
  messagingSenderId: "183343500272",
  appId: "1:183343500272:web:94b04bfefef2f52a476b35",
  measurementId: "G-51NN277QPM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);

// Optional: keep the user logged in across page refreshes.
// Switch to browserSessionPersistence or inMemoryPersistence if preferred.
setPersistence(auth, browserLocalPersistence).catch(console.error);

// Uncomment if testing Cloud Functions locally:
// connectFunctionsEmulator(functions, 'localhost', 5001);
